const UTILS = {
  GetOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY
    };
  },
  OnMutate(targetNodes, callback) {
    var observer = new MutationObserver(callback);

    // Notify me of everything!
    var observerConfig = {
      attributes: true, 
      childList: true, 
      characterData: true
    };

    targetNodes.forEach((node) => {
      observer.observe(node, observerConfig);
    });
  }
};

document.addEventListener('alpine:init', () => {
  Alpine.data('MM_ImageCards', () => ({
    menu: '',
    init() {
      let am = this;
      am.InitSelf()
      am.Render()
    },
    InitSelf() {
      let am = this;
      am.menu = am.$el.dataset.menu
    },
    Render() {
      let am = this;
      document.querySelectorAll(`.megamenu__images[data-menu="${am.menu}"]`).forEach(($section) => {
        if ($section.classList.contains('cards-rendered')) return;
        $section.insertAdjacentHTML('beforeend', am.$el.querySelector('.megamenu__images').innerHTML)
        $section.classList.add('cards-rendered')
      })
    }
  }));

  Alpine.data('StickyFiltersToggle', () => ({
    cache: {},
    flags: {
      active: false
    },
    init() {
      let am = this;
      am.$nextTick(am.InitSelf.bind(am))

      am.$watch('flags.active', () => {
        am.$nextTick(() => {
          am.cache.$sidebar.classList.toggle('is-active', am.flags.active)
          am.cache.$btn_toggle.classList.toggle('is-active', am.flags.active)  
          // console.log(am.cache)
        })
      })
    },
    InitSelf() {
      let am = this;
      am.cache.$btn_toggle = am.$el
      am.cache.$filterBar = am.$el.closest('.collection-filter')
      am.cache.$sidebar = document.querySelector('.grid__item--sidebar')
      am.cache.$btn_closeFilters = document.querySelector('.btn-close-filters')
      if (am.cache.$btn_closeFilters) {
        am.cache.$btn_closeFilters.addEventListener('click', am.CloseFilter.bind(am))
      }
      // console.log(am.cache.$filterBar)

      let btn_offset = UTILS.GetOffset(am.cache.$btn_toggle)
      am.cache.$sidebar.style.setProperty('--filter-active-top', `${am.cache.$filterBar.getClientRects()[0].top}px`)
      am.cache.$sidebar.style.setProperty('--filter-active-left', `${btn_offset.left}px`)
    },
    e_OpenFilter(e) {
      let am = this;
      let btn_offset = UTILS.GetOffset(am.cache.$btn_toggle)
      am.cache.$sidebar.style.setProperty('--filter-active-top', `${am.cache.$filterBar.getClientRects()[0].top}px`)
      am.cache.$sidebar.style.setProperty('--filter-active-left', `${btn_offset.left}px`)

      am.OpenFilter();
    },
    OpenFilter() {
      this.flags.active = true
    },
    CloseFilter() {
      this.flags.active = false
    }
  }));

  Alpine.data('ReadMoreToggle', () => ({
    cache: {},
    init() {
      this.InitSelf()
    },
    InitSelf() {
      let am = this;
      am.$el.classList.add('readmore-enabled')
      am.$el.insertAdjacentHTML('beforeend', '<span class="toggle_Readmore" @click="e_ToggleReadmore">Read more</span>')
    },
    e_ToggleReadmore(e) {
      // console.log(e)
      let $target = e.currentTarget;
      let $readmore  = $target.closest('[data-readmore]')
      $readmore.classList.toggle('is_active')
      let is_active = $readmore.classList.contains('is_active')
      $target.innerText = is_active ? 'Read less' : 'Read more'

      let $collapsible = $readmore.closest('.collapsible-content')
      if ($collapsible) {
        $collapsible.classList.toggle('is-full-open', $readmore.classList.contains('is_active'));
        if (!is_active) {
          let $wrapper = $collapsible.closest('.collapsibles-wrapper');
          let $collapsible_trigger = $wrapper.querySelector('button');
          $collapsible_trigger.dispatchEvent(new CustomEvent('click', {bubbles: true}));
        }
      }
    }
  }));

  Alpine.data('SplitNavItem', () => ({
    cache: {},
    init() {
      let am = this;
      am.cache.$headerWrapper = document.querySelector('.header-wrapper')
      am.MoveItem()

      UTILS.OnMutate([am.cache.$headerWrapper], am.MoveItem.bind(am))
    },
    MoveItem() {
      let am = this;
      let $move_to_Icons = document.querySelector('.header-item--icons .site-nav')
      let $move_to_Nav = document.querySelector('.site-navigation--beside')
      let move_to = am.cache.$headerWrapper.classList.contains('header-wrapper--compressed') ? 'nav' : 'icons'
      let $move_to = move_to == 'nav' ? $move_to_Nav : $move_to_Icons
      if ($move_to) {
        $move_to.insertAdjacentElement(move_to == 'nav' ? 'beforeend' : 'beforebegin', am.$el)
      }
    }
  }));
});